import { render } from "./ViewDocument.vue?vue&type=template&id=508eebe3&scoped=true"
import script from "./ViewDocument.vue?vue&type=script&lang=js"
export * from "./ViewDocument.vue?vue&type=script&lang=js"

import "./ViewDocument.vue?vue&type=style&index=0&id=508eebe3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-508eebe3"]])

export default __exports__